import { axiosNoAuthClient } from '@/shared/apis/config';
import { useTokenStore } from '@/shared/store/token-store';
import { ApiResponse } from '@/shared/types';
import { shouldRefreshOriginalAuthorization } from '@/shared/apis/auth/account-switch-end-policy';

interface PostAdminAccountSwitchTokenRefreshData {
  accessToken: string;
  refreshToken: string;
}

type PostAdminAccountSwitchTokenRefreshResponse =
  ApiResponse<PostAdminAccountSwitchTokenRefreshData>;

export const postAdminAccountSwitchTokenRefreshApi = async (
  refreshToken: string,
  options?: {
    refreshOriginalAuthorization?: () => Promise<string>;
  },
) => {
  const sendRefreshRequest = async (accessToken: string | null) => {
    const response =
      await axiosNoAuthClient.post<PostAdminAccountSwitchTokenRefreshResponse>(
        '/v1.0/admin/account/switch/token-refresh',
        { refreshToken },
        {
          headers: {
            Authorization: accessToken,
          },
        },
      );
    return response.data;
  };

  let accessToken = useTokenStore.getState().accessToken;
  if (!accessToken && options?.refreshOriginalAuthorization) {
    accessToken = await options.refreshOriginalAuthorization();
  }

  try {
    return await sendRefreshRequest(accessToken);
  } catch (error) {
    if (
      !options?.refreshOriginalAuthorization ||
      !shouldRefreshOriginalAuthorization(error)
    ) {
      throw error;
    }

    accessToken = await options.refreshOriginalAuthorization();
    return sendRefreshRequest(accessToken);
  }
};
